/*eslint-disable*/
import React from 'react'
import { BottomSeparator } from './style'
import CommentItem from 'flow/SiteProposal/components/Comments/CommentItem'

const CommentsList = ({commentData, getCommentsData}) => {
  const sortData = commentData.sort((a,b) => (Date.parse(a.updatedAt) < Date.parse(b.updatedAt) ? 1 : ((Date.parse(b.updatedAt) < Date.parse(a.updatedAt)) ? -1 : 0)))
  const commentsList = sortData.map((comment) => {
    const repliesList = comment.Replies.map((reply) => {
      return reply
    })

    const profile = {
      id: comment.UserId,
      firstName: comment.User.firstName,
      lastName: comment.User.lastName,
      roleId: comment.User.Role.id, 
      organisation: comment.User.Role.name, 
      Role: {
        name: comment.User.Role.name
      },
      commentCategory: comment.CommentCategory.name
    }

    return (
      <>
        <BottomSeparator><hr/></BottomSeparator>
        <CommentItem
          key={comment.id}
          commentId={comment.id}
          text={comment.content}
          profile={profile}
          countReplies={repliesList.length}
          createdAt={comment.createdAt}
          updatedAt={comment.updatedAt}
          getCommentsData={getCommentsData}
          isResolved={comment.isResolved}
        />
      </>
    )
  }
  )
  
  return (
    <section>
      {commentsList}
    </section>
  )
}

export default CommentsList